import ExtensionService from './ExtensionService';
import * as moment from 'moment';
import readXlsxFile from 'read-excel-file';

import Excel from "exceljs";
import FileSaver from "file-saver";
import { blockUi, unblockUi } from '../shared/utils';


let MethodService = {};

MethodService.generateId = function(length) {
  var crypto = require("crypto");
  return crypto.randomBytes(length || 12).toString('hex');
}

// roles: ["BuiltinAdmin ", "Admin", "Officer", "TourGuide", "TourAgent", "User"]
MethodService.checkRole = function(stringRoles) {
    var currentUser = JSON.parse(window.localStorage.currentUser);
    let roles = stringRoles.split(",");
    var flag = false;
    roles.forEach(function(item) {
        item = item.trim();
        if (currentUser.roles.indexOf(item) != -1) {
            flag = true;
        }
    })
    return flag;
};

MethodService.getCurrentUser = function() {
    return JSON.parse(window.localStorage.currentUser);
};

MethodService.element = {
    datepicker: {

        formatDate: "dd/MM/yyyy",
        formatDatetime: "dd/MM/yyyy HH:mm",
        valueFormat: "yyyy-MM-ddTHH:mm:ss",
        placeholderDate: "Ngày/Tháng/Năm",
        placeholderDatetime: "Ngày/Tháng/Năm Giờ:Phút",

        formatMonth: "MM/yyyy",
        placeholderMonth: "Tháng/Năm",
        formatYear: "yyyy",
        placeholderYear: "Năm",

    }
};

//required iso 9001 ex: yyyy-dd-mmThh:mm:ssZ
let formatDateMoment = "DD/MM/YYYY";

//ex: iso date to string date  yyyy-dd-mmThh:mm:ssZ - > DD/MM/YYYY
//ex: new Date to iso date  Wed Mar 25 2015 07:00:00 GMT+0700 (Giờ Đông Dương) - > yyyy-dd-mmThh:mm:ssZ || MethodService.formatDate(new Date, "")
MethodService.formatDate = function(value, rule) {
    if (value) {
        var format = "";
        if (rule == "date") {
            format = formatDateMoment;
        } else if (rule == "datetime") {
            format = formatDateMoment + " HH:mm";

        } else if (rule == "aboutTime") {
            format = formatDateMoment + " HH:mm";
        } else {
            format = rule;
        }
        return moment(value).format(format);
    } else {
        return "";
    }
};

MethodService.formatTimestamp = function(value, rule) {
    if (value) {
        var format = "";
        if (rule == "date") {
            format = formatDateMoment;
        } else if (rule == "datetime") {
            format = formatDateMoment + " HH:mm";

        } else if (rule == "aboutTime") {
            format = formatDateMoment + " HH:mm";
        } else {
            format = rule;
        }
        return moment(value, 'YYYY:MM:DDTHH:mm:ss.SSSZZ').format(format);
    } else {
        return "";
    }
};

MethodService.getAboutTime = function(value) {
    if (value) {
        let timeAgo = moment(value).fromNow();
        timeAgo = timeAgo.replace("a few seconds ago", "vài giây trước").replace("minutes ago", "phút trước").replace("hours ago", "giờ trước");
        return timeAgo;
    } else {
        return "";
    }
};

MethodService.addDate = function(value, type, numberTime) {
    if (!value) {
        return "";
    }
    return moment(value).add(numberTime, type).format("YYYY-MM-DDTHH:mm:ss");
};

MethodService.formatterTrimString = function(row, column, cellValue, index, number) {
    if (!number) {
        number = 8;
    }
    var lengthAllow = (column.width ? column.width : column.realWidth) / number;
    if (cellValue) {
        if (cellValue.length > lengthAllow) {
            return cellValue.slice(0, lengthAllow) + "...";
        } else {
            return cellValue;
        }
    } else {
        return "";
    }
};

MethodService.formatterFloatNumber = function(row, column, cellValue, index) {
    if (cellValue) {
        cellValue = parseFloat(cellValue).toFixed(2);
        return cellValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
};

MethodService.stringToObject = function(value) {
    /* console.log(decodeURI(value));
    // console.log(JSON.parse(
    //   '{"' +
    //   decodeURI(value)
    //     .replace(/"/g, '\\"')
    //     .replace(/&/g, '","')
    //     .replace(/<=/g, '":"')
    //     .replace(/>=/g, '":"')
    //     .replace(/=/g, '":"')
    //     .replace(/:regex_i:/g, '":"')
    //     .replace(/:regex:/g, '":"')
    //     .replace(/</g, '":"')
    //     .replace(/>/g, '":"')
    //   +
    //   '"}'
    // ));
    return JSON.parse(
      '{"' +
      decodeURI(value)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/<=/g, '":"')
        .replace(/>=/g, '":"')
        .replace(/=/g, '":"')
        .replace(/:regex_i:/g, '":"')
        .replace(/:regex:/g, '":"')
        .replace(/</g, '":"')
        .replace(/>/g, '":"')
        .replace(/:in:/g, '":"')
        .replace(/:is_null:/g, '":"')
      +
      '"}'
    ); */

    var obj = {};
    if (!value) return obj;

    value.split("&").forEach((frm) => {
        var m = decodeURIComponent(frm).match(/^(\w+(\.\w+)*)(=|>=|<=|<>|!=|:\w+:)(.*)/);
        if (!m) return;
        if (m[1] in obj) return;
        if (m[3].match(/:regex(_\w+)?:/))
            obj[m[1]] = unescapeRegex(m[4]);
        else
            obj[m[1]] = m[4];
    });

    return obj;
};

MethodService.CalculationYear = function(type, last, next) {
    var toGo = "";
    var yearNow = new Date();
    var limit = yearNow.getFullYear();
    if (type == "last") {
        toGo = last;
    }
    if (type == "next") {
        toGo = next;
        limit = limit + next - 1;
    }
    if (type == "last-next") {
        toGo = next + last;
        limit = limit + next - 1;
    }
    var arr = [];
    for (let i = 0; i < toGo; i++) {
        arr.push(limit - i);
    }
    return arr;
};

MethodService.beforeAvatarUpload = function(file, mb) {
    return ((file.size / 1024) / 1024) < mb;
};

MethodService.EndYearBind = function(startYear) {
    let arr = [];
    let setYear = new Date();
    let yearPresent = setYear.getFullYear();

    if (startYear) {
        let rangToYearStart = yearPresent - startYear;
        if (rangToYearStart <= 20) {
            for (let i = rangToYearStart; i >= 1; i--) {
                arr.push(startYear + i);
            }
        } else {
            for (let i = 20; i <= 1; i) {
                arr.push(startYear + i);
            }
        }
    } else {
        for (let i = 0; i < 20; i++) {
            arr.push(yearPresent - i);
        }
    }

    return arr;
};

MethodService.StartYearBind = function(endYear) {
    let arr = [];
    let setYear = new Date();
    let yearPresent = setYear.getFullYear();
    if (endYear) {
        let rangToYearStart = endYear - Number(2000);
        if (rangToYearStart <= 20)
            for (let i = 1; i < rangToYearStart; i++) {
                arr.push(endYear - i);
            }
    } else {
        for (let i = 1; i < 20; i++) {
            arr.push(yearPresent - i);
        }
    }
    return arr;
};

MethodService.stopLadda = function() {
    setTimeout(function() {
        Ladda.stopAll();
    }, 100);
};

MethodService.checkFileSize = function(file, mb) {
    return ((file.size / 1024) / 1024) < mb;
};

MethodService.checkFileType = function (type) {
    let typeFile = ["mp4", "jpg", "png", "jpeg", "mp4", "avi", "mov"];
    if (typeFile.includes(type)) {
        return true;
    } else {
        return false;
    }

};

MethodService.isString = function(value) {
    return typeof value === 'string' || value instanceof String;
};

MethodService.isNumber = function(value) {
    return typeof value === 'number' && isFinite(value);
};

MethodService.isArray = function(value) {
    return value && typeof value === 'object' && value.constructor === Array;
};

MethodService.isFunction = function(value) {
    return typeof value === 'function';
};

MethodService.isObject = function(value) {
    return value && typeof value === 'object' && value.constructor === Object;
};

MethodService.isDate = function(value) {
    return value instanceof Date;
};

MethodService.isBoolean = function(value) {
    return typeof value === 'boolean';
};

MethodService.isNull = function(value) {
    return value === null;
};

MethodService.isUndefined = function(value) {
    return typeof value === 'undefined';
};

MethodService.checkIsDate = function(day, month, year) {

    var d = parseInt(day);
    var m = parseInt(month);
    var y = parseInt(year);

    var date = new Date(y, m - 1, d);
    if (date.getFullYear() == y && date.getMonth() + 1 == m && date.getDate() == d) {
        return true
    }
    return false

};

MethodService.copyObject = function(value) {
    return JSON.parse(JSON.stringify(value));
};



// so sánh 2 object khởi tạo và object trả về, nếu trả về thiếu trường thì lấy trường từ object khởi tạo gán vào objetc trả về
MethodService.checkDifferentObject = function(objectOld, objectNew) {
    function forObject(objectOld) {
        $.each(objectOld, function(key_objectOld, value_objectOld) {
            if (MethodService.isUndefined(objectNew[key_objectOld])) {
                objectNew[key_objectOld] = objectOld[key_objectOld];
            } else if (MethodService.isNull(objectNew[key_objectOld])) {
                objectNew[key_objectOld] = objectOld[key_objectOld];
            } else {
                if (MethodService.isObject(value_objectOld)) {
                    forObject(value_objectOld);
                }
            }
        });
    }
    forObject(objectOld);
    return objectNew;

};

// Tìm các phần tử khác nhau có trong mảng object trả về [],
// nếu truyền [object] thì truyển thêm field
// nếu truyền array thì k cần
MethodService.findListItemDifferent = function(arrItem, field) {
    let arrItemNew = [];
    if (field) {
        $.each(arrItem, (index, item) => {
            if (field) {
                if (item[field]) {
                    if (arrItemNew.indexOf(item[field]) == -1) {
                        arrItemNew.push(item[field]);
                    }
                }
            } else {
                if (arrItemNew.indexOf(item) == -1) {
                    arrItemNew.push(item);
                }
            }

        })
        return arrItemNew;
    } else {
        return arrItem.filter((item, index) => {
            return arrItem.indexOf(item) === index
        })
    }
};

MethodService.findListItemDuplicate = function(arrItem1, arrItem2) {
    return arrItem1.filter(function(val) {
        return arrItem2.indexOf(val) != -1;
    });
};

MethodService.markdownOption = {
    previewStyle: "vertical", //tab | vertical
    mode: "markdown",
    options: {
        minHeight: '200px',
        language: 'vi_VN',
        useCommandShortcut: true,
        useDefaultHTMLSanitizer: true,
        usageStatistics: false,
        hideModeSwitch: true,
        placeholder: 'Nhập nội dung...',
        toolbarItems: [
            'heading',
            'bold',
            'italic',
            'strike',
            'divider',
            'hr',
            'quote',
            'divider',
            'ul',
            'ol',
            'task',
            'indent',
            'outdent',
            'divider',
            'table',
            // 'image',
            'link',
            'divider',
            'code',
            // 'codeblock'
        ]
    }

};

MethodService.markdownModel = {
    dialogImage: false,
    dialogImageTab: "insert",
    dataFormImage: {
        title: null,
        link: null,
        file: null,
    },
    validFormImage: {
        title: [],
        link: [],
        file: [],
    },
};


MethodService.replaceURLImage = function(value) {
    return value.replace(/(!\[[^\]]*\])\([\w.\-\/:]+file\/thumb\?id=([0-9a-fA-F]{24})\)/g, "$1($2)");
};

MethodService.unreplaceURLImage = function(value) {
    return value.replace(/!\[([^\]]*)\]\(([0-9a-fA-F]{24})\)/g, `![$1](${ExtensionService.urlImg}$2)`);
};

MethodService.readExcel = function(dataFile) {
    return new Promise(function(resolve, reject) {
        blockUi();
        readXlsxFile(dataFile).then((rows) => {
            resolve(rows);
            unblockUi()
        }, (error) => {
            window.toastr.error("Đọc file không thành công");
            unblockUi();
            reject(error);
        });
    })

};

MethodService.checkSDT = function(value) {
    return RegExp(/^(0|\+?84|0084)\d{9}$/).test(value);
};

MethodService.toIsoDate = function(value) {
    return moment(value).format("YYYY-MM-DDTHH:mm:ss.SSSZZ");
};

function escapeRegex(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function unescapeRegex(string) {
    return string.replace(/\\([-\/\\^$*+?.()|[\]{}])/g, '$1');
}

MethodService.filterTable = function(jsonFilter) {
    if (jsonFilter) {
        let dataSearch = JSON.parse(jsonFilter);
        let filters = "";
        $.each(dataSearch.value, (key, value) => {
            if (value) {
                if (dataSearch.operator[key]) {
                    let operator = dataSearch.operator[key];
                    // let valueChange = value.replace("*", "\\\*")
                    //   .replace("$", "\\\$")
                    //   .replace("%", "\\\*")
                    //   .replace("[", "\\\[")
                    //   .replace("]", "\\\]")
                    //   .replace("^", "\\\^")
                    //   ; //Sửa lỗi tìm dấu *
                    if (operator == "<+1day") {
                        filters += key + "<" + encodeURIComponent(encodeURIComponent(MethodService.addDate(value, "days", 1))) + "&";
                    } else if (operator == "$vn_text=") {
                        filters += operator + encodeURIComponent(value) + "&";
                    } else if (operator == ":in_that_day:") {
                        filters += key + ">=" + encodeURIComponent(MethodService.toIsoDate(value)) + "&" + key + "<" + encodeURIComponent(MethodService.toIsoDate(MethodService.addDate(value, "days", 1))) + "&";
                    } else if (operator.match(/^:regex(_\w+)?:$/)) {
                        filters += key + operator + encodeURIComponent(escapeRegex(value)) + "&";
                    } else {
                        filters += key + operator + encodeURIComponent(value) + "&";
                    }
                } else {
                    filters += key + "=" + encodeURIComponent(value) + "&";
                }
            }
        });
        return filters.slice(0, -1);
    } else {
        return "";
    }

};

MethodService.checkCardCode = function(cardCode) {
    if (RegExp(/\d/).test(cardCode) && (cardCode.length == 8 || cardCode.length == 16 || cardCode.length == 9)) {
        return true;
    } else {
        return false;
    }
}

MethodService.changeAlias = function(alias) {
    var str = alias.toLowerCase();
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
    str = str.replace(/ + /g, " ");
    str = str.trim();
    return str;
}

MethodService.getAge = function(year, month, day) {
    let today = new Date();
    let birthDate = new Date(year, month - 1, day);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

MethodService.exportExcel = function(dataList) {
    let workbook = new Excel.Workbook();
    workbook.created = new Date();
    workbook.calcProperties.fullCalcOnLoad = false;
    workbook.views = [{
        x: 0,
        y: 0,
        width: 10000,
        height: 20000,
        firstSheet: 0,
        activeTab: 0,
        visibility: "visible"
    }];


    //Tạo sheet DS KDL
    let worksheet = workbook.addWorksheet("DS Khách du lịch", {
        views: [{ state: "frozen", xSplit: 2, ySplit: 3 }]
    });
    // let worksheet = workbook.getWorksheet('DS Khách du lịch');

    worksheet.columns = [
        { header: "STT", key: "stt", width: 8 },
        { header: "Họ và tên khách (bắt buộc)", key: "ho_ten", width: 25 },
        { header: "Số điện thoại", key: "dien_thoai", width: 15 },
        { header: "Mã du lịch/Số thẻ", key: "so_the", width: 20 },
        { header: "Email", key: "email", width: 15 },
        { header: "Giới tính", key: "gioi_tinh", width: 10 },
        { header: "Ngày sinh (bắt buộc)", key: "ngay_sinh", width: 20 },
        { header: "Tháng sinh (bắt buộc)", key: "thang_sinh", width: 20 },
        { header: "Năm sinh (bắt buộc)", key: "nam_sinh", width: 20 },
        { header: "Địa chỉ đẩy đủ", key: "dia_chi", width: 30 },
        { header: "Tỉnh", key: "tinh", width: 25 },
        { header: "Quốc tịch", key: "quoc_tich", width: 20 },
        { header: "Loại giấy tờ", key: "loai_giay_to", width: 15 },
        { header: "Số giấy tờ", key: "so_giay_to", width: 15 },
        { header: "Nơi cấp", key: "noi_cap", width: 20 },
        { header: "Ngày cấp", key: "ngay_cap", width: 10 },
        { header: "Tháng cấp", key: "thang_cap", width: 10 },
        { header: "Năm cấp", key: "nam_cap", width: 10 },
        { header: "Ngày hết hạn", key: "ngay_het_han", width: 15 },
        { header: "Tháng hết hạn", key: "thang_het_han", width: 15 },
        { header: "Năm hết hạn", key: "nam_het_han", width: 15 }
    ];

    let row = worksheet.getRow(1);
    row.eachCell(function(cell, colNumber) {
        row.getCell(colNumber).font = { bold: true };
        row.getCell(colNumber).alignment = {
            vertical: "middle",
            horizontal: "center"
        };
    });

    $.each(dataList, (index, element) => {
        let item = {};
        item.stt = index + 1;
        item.ho_ten =
            (element.first_name ? element.first_name : "") +
            " " +
            (element.last_name ? element.last_name : "");
        item.dien_thoai = element.mobile ? element.mobile : "";
        item.so_the = element.card_code ? element.card_code : (element.register_code ? element.register_code : "");
        item.email = "";
        item.gioi_tinh = element.gioi_tinh ?
            element.gioi_tinh == 1 ?
            "Nữ" :
            element.gioi_tinh == 2 ?
            "Nam" :
            element.gioi_tinh == 3 ?
            "Chưa có thông tin" :
            element.gioi_tinh == 4 ?
            "Khác" :
            "" :
            "";
        item.ngay_sinh = element.dob ?
            element.dob.toString().substring(6, 8) :
            "";
        item.thang_sinh = element.dob ?
            element.dob.toString().substring(4, 6) :
            "";
        item.nam_sinh = element.dob ?
            element.dob.toString().substring(0, 4) :
            "";
        item.dia_chi = "";
        item.tinh = "";
        item.quoc_tich = element.nationality_name ?
            element.nationality_name :
            "";
        item.loai_giay_to = element.cmnd_number ?
            "CMT" :
            element.passport_no ?
            "PASSPORT" :
            "";

        item.so_giay_to = element.cmnd_number ?
            element.cmnd_number :
            element.passport_no ?
            element.passport_no :
            "";
        item.noi_cap = "";
        item.ngay_cap = "";

        item.thang_cap = "";
        item.nam_cap = "";
        item.ngay_het_han = "";
        item.thang_het_han = "";
        item.nam_het_han = "";
        worksheet.addRow(item);
    });

    worksheet
        .getColumn("F")
        .eachCell({ includeEmpty: true }, function(cell, rowNumber) {
            cell.dataValidation = {
                type: "list",
                allowBlank: true,
                formulae: ['"Nam,Nữ,Khác"']
            };
        });
    worksheet
        .getColumn("K")
        .eachCell({ includeEmpty: true }, function(cell, rowNumber) {
            cell.dataValidation = {
                type: "list",
                allowBlank: true,
                formulae: ["Province!$B:$B"]
            };
        });
    worksheet
        .getColumn("M")
        .eachCell({ includeEmpty: true }, function(cell, rowNumber) {
            cell.dataValidation = {
                type: "list",
                allowBlank: true,
                formulae: ['"CMT,CCCD,PASSPORT"']
            };
        });

    //Tạo sheet Province
    let itemProvince = [
        ["5c36af780192752924007972", "Hà Nội"],
        ["5c36af780192752924007973", "Hà Giang"],
        ["5c36af780192752924007974", "Cao Bằng"],
        ["5c36af780192752924007975", "Bắc Kạn"],
        ["5c36af780192752924007976", "Tuyên Quang"],
        ["5c36af780192752924007977", "Lào Cai"],
        ["5c36af780192752924007978", "Điện Biên"],
        ["5c36af780192752924007979", "Lai Châu"],
        ["5c36af78019275292400797a", "Sơn La"],
        ["5c36af78019275292400797b", "Yên Bái"],
        ["5c36af78019275292400797c", "Hòa Bình"],
        ["5c36af78019275292400797d", "Thái Nguyên"],
        ["5c36af78019275292400797e", "Lạng Sơn"],
        ["5c36af78019275292400797f", "Quảng Ninh"],
        ["5c36af780192752924007980", "Bắc Giang"],
        ["5c36af780192752924007981", "Phú Thọ"],
        ["5c36af780192752924007982", "Vĩnh Phúc"],
        ["5c36af780192752924007983", "Bắc Ninh"],
        ["5c36af780192752924007984", "Hải Dương"],
        ["5c36af780192752924007985", "Hải Phòng"],
        ["5c36af780192752924007986", "Hưng Yên"],
        ["5c36af780192752924007987", "Thái Bình"],
        ["5c36af780192752924007988", "Hà Nam"],
        ["5c36af780192752924007989", "Nam Định"],
        ["5c36af78019275292400798a", "Ninh Bình"],
        ["5c36af78019275292400798b", "Thanh Hóa"],
        ["5c36af78019275292400798c", "Nghệ An"],
        ["5c36af78019275292400798d", "Hà Tĩnh"],
        ["5c36af78019275292400798e", "Quảng Bình"],
        ["5c36af78019275292400798f", "Quảng Trị"],
        ["5c36af780192752924007990", "Thừa Thiên Huế"],
        ["5c36af790192752924007991", "Đà Nẵng"],
        ["5c36af790192752924007992", "Quảng Nam"],
        ["5c36af790192752924007993", "Quảng Ngãi"],
        ["5c36af790192752924007994", "Bình Định"],
        ["5c36af790192752924007995", "Phú Yên"],
        ["5c36af790192752924007996", "Khánh Hòa"],
        ["5c36af790192752924007997", "Ninh Thuận"],
        ["5c36af790192752924007998", "Bình Thuận"],
        ["5c36af790192752924007999", "Kon Tum"],
        ["5c36af79019275292400799a", "Gia Lai"],
        ["5c36af79019275292400799b", "Đắk Lắk"],
        ["5c36af79019275292400799c", "Đắk Nông"],
        ["5c36af79019275292400799d", "Lâm Đồng"],
        ["5c36af79019275292400799e", "Bình Phước"],
        ["5c36af79019275292400799f", "Tây Ninh"],
        ["5c36af7901927529240079a0", "Bình Dương"],
        ["5c36af7901927529240079a1", "Đồng Nai"],
        ["5c36af7901927529240079a2", "Bà Rịa - Vũng Tàu"],
        ["5c36af7901927529240079a3", "Hồ Chí Minh"],
        ["5c36af7901927529240079a4", "Long An"],
        ["5c36af7901927529240079a5", "Tiền Giang"],
        ["5c36af7901927529240079a6", "Bến Tre"],
        ["5c36af7901927529240079a7", "Trà Vinh"],
        ["5c36af7901927529240079a8", "Vĩnh Long"],
        ["5c36af7901927529240079a9", "Đồng Tháp"],
        ["5c36af7901927529240079aa", "An Giang"],
        ["5c36af7901927529240079ab", "Kiên Giang"],
        ["5c36af7901927529240079ac", "Cần Thơ"],
        ["5c36af7901927529240079ad", "Hậu Giang"],
        ["5c36af7901927529240079ae", "Sóc Trăng"],
        ["5c36af7901927529240079af", "Bạc Liêu"],
        ["5c36af7901927529240079b0", "Cà Mau"]
    ];

    let sheetProvince = workbook.addWorksheet("Province");
    sheetProvince.state = "hidden";
    $.each(itemProvince, (index, element) => {
        sheetProvince.addRow(element);
    });

    workbook.xlsx.writeBuffer().then(function(data) {
        var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        FileSaver.saveAs(blob, "DSKhachDuLichDaCapMS.xlsx");
    });
}

MethodService.changeNumberToString = (number) => {
    if (MethodService.isNumber(number)) {
        if (number >= 1000000000) {
            return Math.floor(number / 1000) + "B";
        } else if (number >= 1000000) {
            return Math.floor(number / 1000000) + "M";
        } else if (number >= 1000) {
            return Math.floor(number / 1000000000) + "N";
        } else {
            return number;
        }
    } else {
        return number;
    }
}


MethodService.exportExcelCheckinDDAT = function(dataList) {
    let workbook = new Excel.Workbook();
    workbook.created = new Date();
    workbook.calcProperties.fullCalcOnLoad = false;
    workbook.views = [{
        x: 0,
        y: 0,
        width: 10000,
        height: 20000,
        firstSheet: 0,
        activeTab: 0,
        visibility: "visible"
    }];


    //Tạo sheet DS KDL
    let worksheet = workbook.addWorksheet("DS Khách du lịch", {
        views: [{ state: "frozen", xSplit: 0, ySplit: 1 }]
    });
    // let worksheet = workbook.getWorksheet('DS Khách du lịch');

    worksheet.columns = [
        { header: "Thời điểm check-in", key: "thoi_diem_check_in", width: 25 },
        { header: "Đối tượng tạo", key: "ten_nguoi_tao", width: 40 },
        { header: "Khách du lịch", key: "ten_nguoi_check_in", width: 40 },
        { header: "Ngày sinh", key: "ngay_sinh", width: 20 },
        { header: "Giới tính", key: "gioi_tinh", width: 20 },
        { header: "Số CMND/CCCD", key: "so_giay_to", width: 25 },
        { header: "Địa chỉ", key: "dia_chi", width: 50 },
        { header: "Số điện thoại", key: "dien_thoai", width: 25 },
        { header: "Email", key: "email", width: 30 }
    ];

    $.each(dataList, (index, element) => {
        let item = {};
        item.thoi_diem_check_in = element.thoi_diem_check_in ? MethodService.formatDate(element.thoi_diem_check_in,"datetime") : "Chưa có thông tin";
        item.ten_nguoi_tao = element.ten_nguoi_tao ? element.ten_nguoi_tao : "Chưa có thông tin";
        item.ten_nguoi_check_in = element.ten_nguoi_check_in ? element.ten_nguoi_check_in : "Chưa có thông tin";
        item.ngay_sinh = element.ngay_sinh ? element.ngay_sinh : "Chưa có thông tin";
        item.gioi_tinh = element.gioi_tinh ? element.gioi_tinh : "Chưa có thông tin";
        item.so_giay_to = element.so_giay_to ? element.so_giay_to : "Chưa có thông tin";
        item.dia_chi = element.dia_chi ? element.dia_chi : "Chưa có thông tin";
        item.dien_thoai = element.dien_thoai ? element.dien_thoai : "Chưa có thông tin";
        item.email = element.email ? element.email : "Chưa có thông tin";
        worksheet.addRow(item);
    });

    worksheet.getRow(1).height = 20;
    worksheet.eachRow((row, rowNumber) => {
        row.eachCell(function (cell, colNumber) {
            if (rowNumber == 1) {
                // First set the background of header row
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "f5b914" }
                };
                cell.font = { bold: true };
                cell.alignment = {
                    vertical: "middle",
                    horizontal: "center",
                    wrapText: true
                };
            } else {
                cell.alignment = {
                    vertical: "middle",
                    wrapText: true
                };
            }

            // Set border of each cell
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
            };
        });
    });


    workbook.xlsx.writeBuffer().then(function(data) {
        var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        FileSaver.saveAs(blob, "DanhSachCheckInDDAT.xlsx");
    });
}

MethodService.exportExcelMerchant = function(dataList) {
  let workbook = new Excel.Workbook();
  workbook.created = new Date();
  workbook.calcProperties.fullCalcOnLoad = false;
  workbook.views = [{
    x: 0,
    y: 0,
    width: 10000,
    height: 20000,
    firstSheet: 0,
    activeTab: 0,
    visibility: "visible"
  }];


  //Tạo sheet DS KDL
  let worksheet = workbook.addWorksheet("Quản lý merchant", {
    views: [{ state: "frozen", xSplit: 0, ySplit: 1 }]
  });

  worksheet.columns = [
    { header: "Mã số tài khoản", key: "ma_so_tai_khoan", width: 12 },
    { header: "Số điện thoại", key: "so_dien_thoai", width: 15 },
    { header: "Tên điểm đến", key: "ten_don_vi", width: 35 },
    { header: "Loại hình", key: "loai_hinh", width: 22 },
    { header: "Mã số thuế", key: "ma_so_thue", width: 20 },
    { header: "Địa chỉ", key: "dia_chi", width: 40 },
    { header: "Thời điểm đăng ký", key: "thoi_diem_dang_ky", width: 18 },
    { header: "Điểm thanh toán", key: "diem_thanh_toan", width: 16 },
    { header: "Trạng thái xử lý", key: "trang_thai", width: 16 }
  ];

  $.each(dataList, (index, element) => {
      let item = {};
      item.ma_so_tai_khoan = element.du_lieu_khai_bao && element.du_lieu_khai_bao.user_account ? element.du_lieu_khai_bao.user_account : "";
      item.so_dien_thoai =
        element.thong_tin_chung &&
        element.thong_tin_chung.nguoi_dai_dien &&
        element.thong_tin_chung.nguoi_dai_dien.dien_thoai
          ? element.thong_tin_chung.nguoi_dai_dien.dien_thoai &&
            element.thong_tin_chung.nguoi_dai_dien.dien_thoai.length == 11
              ? element.thong_tin_chung.nguoi_dai_dien.dien_thoai.replace(/^\d{2}/,'0')
              : element.thong_tin_chung.nguoi_dai_dien.dien_thoai
          : "";
      item.ten_don_vi =
        element.thong_tin_chung &&
        element.thong_tin_chung.ten
          ? element.thong_tin_chung.ten
          : "";
      item.loai_hinh = element.ten_loai_diem_den ? element.ten_loai_diem_den : "";
      item.ma_so_thue =
        element.thong_tin_chung &&
        element.thong_tin_chung.giay_to &&
        element.thong_tin_chung.giay_to.so_giay_to
          ? element.thong_tin_chung.giay_to.so_giay_to
          : "";
      item.dia_chi =
        element.thong_tin_chung &&
        element.thong_tin_chung.dia_chi &&
        element.thong_tin_chung.dia_chi.dia_chi
          ? element.thong_tin_chung.dia_chi.dia_chi
          : "";
      item.thoi_diem_dang_ky = element.thoi_diem_tao ? MethodService.formatDate(element.thoi_diem_tao, 'datetime') : "";
      item.diem_thanh_toan = element.isMerchant === true ? 'True' : "False";
      item.trang_thai = element.processingStatus === true ? 'Đang xử lý' : element.processingStatus === false ?  "Đã xử lý" : '';
      worksheet.addRow(item);
  });

  worksheet.getRow(1).height = 30;
  worksheet.eachRow((row, rowNumber) => {
    row.eachCell(function (cell, colNumber) {
      if (rowNumber == 1) {
        // First set the background of header row
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "f5b914" }
        };
        cell.font = { bold: true };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
        if (colNumber == 1 || colNumber == 2 || colNumber == 7 || colNumber == 8 || colNumber == 9) cell.alignment.horizontal = "center"
      }

      // Set border of each cell
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });


  workbook.xlsx.writeBuffer().then(function(data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    FileSaver.saveAs(blob, "DanhSachMerchant.xlsx");
  });
}

export default MethodService;
